import type { Messages } from "./messages.ts";

/** Query/cookie value that selects the pseudo-locale where it is allowed (never in production). */
export const PSEUDO_LOCALE = "en-XA";

/** True only outside production builds: the pseudo-locale is a developer tool, not a language users can pick. */
export function pseudoLocaleAllowed(nodeEnv: string | undefined): boolean {
  return nodeEnv !== "production";
}

/** English with every sentence accented and padded: shown where the real catalog is bypassed, text stays plain. */
export async function loadPseudoMessages(): Promise<Messages> {
  // Both imports are dynamic so a production bundle never loads the ICU printer for a language nobody can pick.
  const [{ default: english }, { pseudoLocalizeCatalog }] = await Promise.all([
    import("../locales/en/index.ts"),
    import("./pseudo.ts"),
  ]);
  return Object.fromEntries(
    Object.entries(english as Messages).map(([namespace, catalog]) => [namespace, pseudoLocalizeCatalog(catalog)]),
  );
}
